export default __webpack_public_path__ + "static/129-15b0dbbe62b9752ea87e0581fcf39306.gif";